module.exports = __webpack_public_path__ + "media/images/bg-preparingPlan-0f73a7fb.png";